import React, {useCallback, useEffect} from 'react';
import MultipleChoiceButton from "./multipleChoiceButton";
import CheckBoxes from "./checkboxes";
import {useStoreActions, useStoreState} from "easy-peasy";
import {playQ4Animation} from "../utils/animation";

const renderButtons = props =>
    <fieldset> {
        props.data.options.map((option, index) =>
            props.questionIndex === 4 ?
                (
                    <CheckBoxes
                        questionIndex={props.questionIndex}
                        key={`multiple_choice_button_${props.questionIndex}_${index}`}
                        index={index}
                        answer={option.answer}
                        result={option.result}
                        nextQuestion={option.nextQuestion}
                    />
                ) : (
                    <MultipleChoiceButton
                        questionIndex={props.questionIndex}
                        key={`multiple_choice_button_${props.questionIndex}_${index}`}
                        index={index}
                        answer={option.answer}
                        result={option.result}
                        nextQuestion={option.nextQuestion}
                    />
                ))}
    </fieldset>;

const shouldShowResultsButton = (index, answers) => {
    const isLastQuestion = index === 4;
    if (isLastQuestion) {
        const inputs = document.querySelectorAll(`input[type=checkbox]`);

        return isLastQuestion && inputs && Array.from(inputs).some(el => el.checked);
    } else {
        return false;
    }
};

const MultipleChoice = props => {
    // Actions
    const goto                = useStoreActions(actions => actions.path.goto);
    const setCurrentAnimation = useStoreActions(actions => actions.animation.setCurrent);
    useEffect(() => {
        if (document.querySelector(`.multiple-choice-container`)) {
            document.querySelector(`.multiple-choice-container`).focus();
        }
    });

    // State
    const answers = useStoreState(state => state.answers.current);
    const onClick = useCallback(() => {
        window.dataLayer.push(`${answers[0]}_SeeResults`);
        playQ4Animation(setCurrentAnimation, answers[0]);
        goto(`/results`);
    }, [goto, answers, setCurrentAnimation]);

    const showResBtn = shouldShowResultsButton(props.questionIndex, answers);

    return (
        <div className="multiple-choice-container">
            <p>{props.data.topCopy}</p>
            <h2 id={`header_${props.questionIndex}`} className={`q${props.questionIndex}-question`}>{props.data.question}</h2>
            <p className="subheader">{props.data.subheader}</p>
            <div className="options-container">
                {renderButtons(props)}
            </div>
            <button className={`cta-btn ${showResBtn ? `` : `hidden`}`} onClick={onClick} aria-controls="App">See your results</button>
        </div>
    );
};

export default MultipleChoice;
